module.exports = __webpack_public_path__ + "static/media/pn_billboard_930pxWide_For1350pxWideScreen@2x.c78ad6b7.png";